import Service from "lib/models/Service";
import type { LoginRequest, LoginResponse } from "lib/models/Service";

export type { LoginRequest, LoginResponse };

export default class AuthService extends Service {
  // TODO
}
